<a [routerLink]="data.url" style="text-decoration: none;">
  <mat-card class="home-button-card">
    <div class="home-button-card-container">
      <div *ngIf="data.icon">
        <mat-icon>{{data.icon}}</mat-icon>
      </div>
      <div style="margin: 20px;"><span>{{data.title}}</span></div>
    </div>
  </mat-card>
</a>